import HomeIcon from '@mui/icons-material/Home';
import AppsIcon from '@mui/icons-material/Apps';

import LogoutIcon from '@mui/icons-material/Logout';

import BusinessIcon from '@mui/icons-material/Business';
import LayersIcon from '@mui/icons-material/Layers';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import PaymentIcon from '@mui/icons-material/Payment';



export const navData = [
    // {
    //     id: 0,
    //     icon: <HomeIcon/>,
    //     text: "Home",
    //     link: "home"
    // },
    {
        id: 1,
        icon: <AppsIcon/>,
        text: "Dashboard",
        link: "zaptrance-dashboard"
    },
    {
        id: 2,
        icon: <BusinessIcon/>,
        text: "Institutions",
        link: "zaptrance-institutions"
    },
    {
        id: 3,
        icon: <LayersIcon/>,
        text: "Programs",
        link: "zaptrance-programs"
    },
    {
        id: 4,
        icon: <PeopleIcon/>,
        text: "Users",
        link: "zaptrance-users"
    },
    {
        id: 5,
        icon: <PaymentIcon/>,
        text: "Payment",
        link: "zaptrance-payment"
    },
    {
        id: 6,
        icon: <SettingsIcon/>,
        text: "Settings",
        link: "zaptrance-settings-password"
    },
    {
        id: 7,
        icon: <VerifiedOutlinedIcon/>,
        text: "Verification Request",
        link: "zaptrance-verification-request"
    },
    {
        id: 8,
        icon: <LogoutIcon/>,
        text: "Logout",
        link: "logout"
    },
]